export const categories = [
  {
    name: 'Construction',
    href: 'search?search=construction&sectors=Construction&sort=relevance',
    icon: '🏗️',
    count: '2,345',
    image: 'https://images.pexels.com/photos/162553/keys-workshop-mechanic-tools-162553.jpeg?auto=compress&cs=tinysrgb&w=400'
  },
  {
    name: 'Agricultural',
    href: 'search?search=agricultural&sectors=Agricultural&sort=relevance',
    icon: '🌾',
    count: '856',
    image: 'https://images.pexels.com/photos/1108572/pexels-photo-1108572.jpeg?auto=compress&cs=tinysrgb&w=400'
  },
  {
    name: 'Livestock and By-Products',
    href: 'search?search=Livestock+and+By-Products&sectors=Livestock+and+By-Products&sort=relevance',
    icon: '🐄',
    count: '1,234',
    image: 'https://agrigro.com/cdn/shop/articles/brproducts_featimg.jpg?v=1704299182'
  },
  {
    name: 'Chemicals',
    href: 'search?search=chemicals&sectors=Chemichals&sort=relevance',
    icon: '🧪',
    count: '1,789',
    image: 'https://images.pexels.com/photos/2280547/pexels-photo-2280547.jpeg?auto=compress&cs=tinysrgb&w=400'
  },
  {
    name: 'Housing',
    href: 'search?search=housing&sectors=Housing&sort=relevance',
    icon: '🏡',
    count: '1,500',
    image: 'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&w=400'
  },
  {
    name: 'Equipment',
    href: 'search?search=equipment&sectors=Equipment&sort=relevance',
    icon: '🧰',
    count: '2,109',
    image: 'https://images.pexels.com/photos/162553/keys-workshop-mechanic-tools-162553.jpeg?auto=compress&cs=tinysrgb&w=400'
  }
];

export const featuredProducts = [
  {
    id: 1,
    name: 'Acero Inoxidable 316L',
    supplier: 'SteelPro Industries',
    price: '$2,850/ton',
    rating: 4.8,
    location: 'Shanghai, China',
    image: 'https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&w=400',
    verified: true,
    specs: ['Grado 316L', 'ASTM A240', 'EN 10088-2']
  },
  {
    id: 2,
    name: 'Polietileno HDPE',
    supplier: 'Polymer Solutions Ltd',
    price: '$1,420/ton',
    rating: 4.6,
    location: 'Houston, USA',
    image: 'https://images.pexels.com/photos/3735187/pexels-photo-3735187.jpeg?auto=compress&cs=tinysrgb&w=400',
    verified: true,
    specs: ['Densidad 0.94-0.97', 'FDA Aprobado', 'ISO 9001']
  },
  {
    id: 3,
    name: 'Cobre Electrolítico',
    supplier: 'Copper Global',
    price: '$8,950/ton',
    rating: 4.9,
    location: 'Santiago, Chile',
    image: 'https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&w=400',
    verified: true,
    specs: ['99.9% Pureza', 'LME Grade A', 'BS EN 1978']
  },
  {
    id: 4,
    name: 'Algodón Orgánico',
    supplier: 'Natural Fibers Co',
    price: '$3,200/ton',
    rating: 4.7,
    location: 'Mumbai, India',
    image: 'https://images.pexels.com/photos/6764010/pexels-photo-6764010.jpeg?auto=compress&cs=tinysrgb&w=400',
    verified: true,
    specs: ['GOTS Certificado', 'Fibra Larga', 'Blanco Natural']
  }
];

export const suppliers = [
  {
    name: 'Industrial Materials Corp',
    rating: 4.9,
    orders: '2,450+',
    location: 'Germany',
    specialties: ['Metals', 'Chemicals'],
    logo: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=100'
  },
  {
    name: 'Global Raw Supply',
    rating: 4.8,
    orders: '1,890+',
    location: 'Singapore',
    specialties: ['Plastics', 'Polymers'],
    logo: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=100'
  },
  {
    name: 'Premier Resources Ltd',
    rating: 4.7,
    orders: '3,200+',
    location: 'Canada',
    specialties: ['Minerals', 'Metals'],
    logo: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=100'
  }
];